// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2sO84","preloader":"styles_preloader__2RJJ0","spin":"styles_spin__2-dwd"};